<template>
  <transition name="msgbotransitionx-fade">
    <div class="rd-message-box-back" @click.self="handleWrapperClick" v-show="visible">
      <div class="rd-message-box">
        <div class="message-title">
          <i :class="{
            'iconfont jingshi': !iconClass,
            iconClass,
          }"
            :style="{'color': type === 'danger' ? '#F53E3E' : ''}"
          ></i>
          <span class="message-title-content">{{ title || '提示' }}</span>
          <button
            size="small"
            type="button"
            class="message-box-close"
            aria-label="Close"
            v-if="showCloseButton"
            @click="handleAction('close')"
          >
            <i class="el-message-box__close iconfont guanbi3"></i>
          </button>
        </div>
        <div class="message-box-content" v-if="message !== ''">
          <slot>
          </slot>
          <p v-if="!dangerouslyUseHTMLString">{{ message }}</p>
          <p v-else v-html="message"></p>
        </div>
        <div class="message-box-footer">
          <div class="message-is-tips">
            <el-checkbox
              v-if="showTemporaryChecked"
              class="switch-temp-text"
              v-model="checkedModel"
            >暂不提示</el-checkbox>
            <span
              v-if="showAlwaysButton"
              class="switch-title-text"
              @click="handleAction('clickAlwaysTips')"
            >永不提示</span>
          </div>
          <div class="message-box-button">
            <el-button
              size="small"
              v-if="showCancelButton"
              @click="handleAction('cancel')"
              class="cancel-button"
            >
              {{ cancelButtonText || '取消' }}
            </el-button>
            <el-button
              v-if="showMoreDefaultBtn"
              size="small"
              @click="handleAction('moreDefaultBtn')"
              class="cancel-button"
            >
              {{ moreDefaultBtnButtonText || '查看更多' }}
            </el-button>
            <el-button
              v-if="showDiaryDraftEdit"
              size="small"
              type="text"
              @click="handleAction('showDiaryDraftEdit')"
              class="edit-draft-button cancel-button"
            >
              {{ diaryDraftEditText || '编辑草稿' }}
            </el-button>
            <el-dropdown
              v-if="showConfirmButtonDropdown"
              class="rd-message-box-dropdown"
              @command="confirmButtonDropdownCommandHandler"
            >
              <el-button
                size="small"
                :type="type"
                ref="confirm"
              >
                {{ confirmButtonText || '确定' }}
              </el-button>
              <template #dropdown>
                <el-dropdown-menu class="rd-message-box-dropdown-menu">
                  <el-dropdown-item
                    v-for="(item, index) in confirmButtonDropdownList"
                    :key="index"
                    :command="index"
                  >
                    {{ item }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <template v-else>
              <el-button
                v-if="showConfirmButton"
                size="small"
                :type="type"
                ref="confirm"
                @click="handleAction('confirm')"
              >
                {{ confirmButtonText || '确定' }}
              </el-button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'RdMessageBox',
  data() {
    return {
      visible: false,
      type: 'primary', // primary 正常 danger 警示类
      title: '',
      message: '',
      iconClass: '',
      showCloseButton: false,
      showTemporaryChecked: false,
      showAlwaysButton: false,
      dangerouslyUseHTMLString: false,
      showConfirmButton: true,
      showCancelButton: true,
      showMoreDefaultBtn: false,
      showConfirmButtonDropdown: false,
      showDiaryDraftEdit: false,
      diaryDraftEditText: '',
      confirmButtonText: '',
      cancelButtonText: '',
      moreDefaultBtnButtonText: '',
      confirmButtonDropdownList: [],
      confirmButtonDropdownId: 0,
      callback: null,
      checkedModel: false,
      closeOnClickModal: true,
      closeOnHashChange: true,
      changeHashClose: true,
    };
  },

  mounted() {
    this.$nextTick(() => {
      if (this.closeOnHashChange) {
        window.addEventListener('hashchange', this.hashchange);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.hashchange);
    this.doClose();
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.confirm.$el.focus();
      }
    },
  },
  methods: {
    handleWrapperClick() {
      if (this.closeOnClickModal) {
        this.handleAction('cancel');
      }
    },
    handleAction(action) {
      this.action = action;
      this.doClose();
    },
    confirmButtonDropdownCommandHandler(command) {
      this.confirmButtonDropdownId = command;
      this.handleAction('confirm');
    },
    hashchange(e) {
      if (!this.changeHashClose) {
        return;
      }
      this.doClose();
    },

    doClose() {
      if (!this.visible) return;
      this.visible = false;
      setTimeout(() => {
        if (this.action) this.callback(this.action, this);
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./RdMessageBox";
.msgbotransitionx-fade-enter-active {
  animation: msgbotransitionx-fade-in .3s;
}
.msgbotransitionx-fade-leave-active {
  animation: msgbotransitionx-fade-out .3s;
}

@keyframes msgbotransitionx-fade-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes msgbotransitionx-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/messageBox/RdMessageBox.vue